export const sortMappingIdeaList: Record<string, string> = {
  tickerCode: 'Ticker',
  tickerName: 'Name',
  tickerLegalName: 'LocalName',
  direction: 'Direction',
  targetMarketValue: 'TargetMarketValue',
  currentMarketValue: 'CurrentMarketValue',
  totalReturnPct: 'TotalReturnPct',
  dailyPnl: 'DailyPnl',
  quarterPnl: 'QuarterPnl',
  currentTotalPnl: 'TotalPnl',
  avgCost: 'AvgCost',
  shares: 'Shares',
  currentQty: 'Shares',
  duration: 'Duration',
  createdAt: 'CreatedAt',
  firmName: 'FirmName',
  state: 'State',
  pctGMV: 'PctGMV',
  pctBP: 'PctBP',
  contributor: 'Contributor',
  closedAt: 'ClosedAt',
  lastFilledResult: 'LastFilledResult',
  lastFillingState: 'LastFillingState',
  cumulativePnl: 'CumulativePnl',
  dailyReturnPct: 'DailyReturnPct',
}
